import { useAuthContext } from "../hooks/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({
  children,
}: {
  children: JSX.Element;
}) {
  const { user } = useAuthContext();
  const location = useLocation();

  // Not authenticated
  if (!user) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  // Enforce admin-only access for /admin routes
  if (location.pathname.startsWith("/admin") && user.role !== "admin") {
    // If the user is not an admin, redirect to the user panel
    return <Navigate to="/user/announcements" replace />;
  }

  return children;
}
